import { render } from "./MenuSection.vue?vue&type=template&id=3cdd76c0&scoped=true"
import script from "./MenuSection.vue?vue&type=script&lang=js"
export * from "./MenuSection.vue?vue&type=script&lang=js"

import "./MenuSection.vue?vue&type=style&index=0&id=3cdd76c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cdd76c0"]])

export default __exports__